import React from "react";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header/Header";
import Custombutton from "../../utils/Custombutton";
import { Link } from "react-router-dom";

const DVPN = () => {
  return (
    <div
      className="hero heros dvpn"
      style={{
        height: "auto  ",
        background: " linear-gradient(61deg, #070707 50.84%, #222 96.86%)",
      }}
    >
      <div className="px-3 py-3 px-xxl-4 py-xxl-4">
        <Header />
        <div className="container mt-4">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <img className="w-100" src="/assets/images/DVPN.png" alt="DVPN" />
            </div>
            <div className="col-lg-6">
              <h1>
                COSMIC <br />
                <span className="gradient-text">Network</span>
              </h1>
              <p>
                Our DVPN services offer censorship resistant internet access,
                enhanced safety via our decentralized model, open source
                network, and a peer-to-peer marketplace for buying and selling
                the bandwidth.
              </p>
              <div className="stats">
                <p>Total Downloads</p>
                <h3>8237</h3>
              </div>
              <div className="row mt-4">
                <div className="col-lg-6 mb-4">
                  <div className="stats">
                    <p style={{ fontSize: "20px" }}>Total Sessions</p>
                    <h3 style={{ fontSize: "30px" }}>4807</h3>
                  </div>
                </div>
                <div className="col-lg-6 mb-4">
                  {" "}
                  <div className="stats">
                    <p style={{ fontSize: "20px" }}>Unique Users</p>
                    <h3 style={{ fontSize: "30px" }}>4883</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 mb-4">
              <img
                className="w-100"
                src="/assets/images/poweredbyai.png"
                alt="poweredbyai"
              />
            </div>
            <div className="col-lg-6 mb-4">
              <h4>Powered BY AI</h4>
              <p>
                Cosmic runs on a decentralized network of Nodes. Install our PC
                package to operate a Node and earn passive income through our
                rewards program.
              </p>
            </div>
          </div>
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 mb-4 order-lg-1 order-2">
              <h4>
                Private <br />
                Decentralized <br />
                Secure
              </h4>
              <p>
                Cosmic runs on a decentralized network of Nodes. Install our PC
                package to operate a Node and earn passive income through our
                rewards program.
              </p>
            </div>
            <div className="col-lg-6 mb-4 order-lg-2 order-1">
              <img
                className="w-100"
                src="/assets/images/PrivateDecentralizedSecure.png"
                alt="PrivateDecentralizedSecure"
              />
            </div>
          </div>

          <div className="row align-items-center mt-5">
            <div className="col-lg-6 mb-4">
              <img
                className="w-100"
                src="/assets/images/AutoConnect.png"
                alt="AutoConnect"
              />
            </div>
            <div className="col-lg-6 mb-4">
              <h4>Auto Connect</h4>
              <p>
                Cosmic runs on a decentralized network of Nodes. Install our PC
                package to operate a Node and earn passive income through our
                rewards program.
              </p>
            </div>
          </div>
          <div className="row spacing">
            <div className="col-lg-3 mb-4">
              <div className="position-relative">
                <div className="download">
                  <h5>Window</h5>

                  <svg
                    width="190"
                    height="191"
                    className="gradient-svg"
                    viewBox="0 0 190 191"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="gradient-path"
                      d="M86.796 141.48L41.2109 134.895V96.401H86.796V141.48ZM86.796 92.8555H41.2109V56.3874L86.796 49.8029V92.8555ZM149.096 150.09L90.3416 141.48V96.401H149.096V150.09ZM149.096 92.8555H90.3416V49.8029L149.096 41.1924V92.8555Z"
                      fill="url(#paint0_linear_3638_52092)" // Initially set to grey gradient
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3638_52092"
                        x1="138.739"
                        y1="128.799"
                        x2="69.5526"
                        y2="58.6085"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#262626" />
                        <stop offset="1" stop-color="#8C8C8C" />
                      </linearGradient>

                      <linearGradient
                        id="paint1_linear_3638_52092"
                        x1="138.739"
                        y1="128.799"
                        x2="69.5526"
                        y2="58.6085"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00D6FF" />
                        <stop offset="1" stop-color="#00FF86" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <Custombutton
                    className={"btn-outline w-100"}
                    label={"download now"}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="position-relative">
                <div className="download">
                  <h5>Android</h5>

                  <svg
                    className="gradient-svg"
                    width="191"
                    height="190"
                    viewBox="0 0 191 190"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      className="gradient-path"
                      d="M128.333 79.9636L139.165 61.2444C140.106 59.4196 139.4 57.1827 137.634 56.2409C135.927 55.3579 133.808 55.8877 132.748 57.5359L121.682 76.6083C104.846 69.4856 85.8916 69.4856 69.0562 76.6083L57.9895 57.5359C56.8711 55.8288 54.5753 55.2991 52.8682 56.3586C51.22 57.4182 50.6902 59.5374 51.5732 61.2444L62.4044 79.9636C44.1562 90.3827 32.2654 109.161 30.6172 130.117H160.121C158.472 109.161 146.582 90.3827 128.333 79.9636ZM65.9363 113.929C61.8746 113.929 58.5782 110.632 58.5782 106.571C58.5782 102.509 61.8746 99.2125 65.9363 99.2125C69.998 99.2125 73.2944 102.509 73.2944 106.571C73.2944 110.632 69.998 113.929 65.9363 113.929ZM124.801 113.929C120.74 113.929 117.443 110.632 117.443 106.571C117.443 102.509 120.74 99.2125 124.801 99.2125C128.863 99.2125 132.16 102.509 132.16 106.571C132.16 110.632 128.863 113.929 124.801 113.929Z"
                      fill="url(#paint0_linear_3638_52103)"
                    />

                    <defs>
                      <linearGradient
                        id="paint0_linear_3638_52103"
                        x1="70.3584"
                        y1="162.906"
                        x2="111.121"
                        y2="83.5091"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#262626" />
                        <stop offset="1" stop-color="#8C8C8C" />
                      </linearGradient>

                      <linearGradient
                        id="paint1_linear_3638_52103"
                        x1="70.3584"
                        y1="162.906"
                        x2="111.121"
                        y2="83.5091"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00d6ff" />
                        <stop offset="1" stop-color="#00ff86" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <Custombutton
                    className={"btn-outline w-100"}
                    label={"download now"}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="position-relative">
                <div className="download">
                  <h5>ios</h5>

                  <svg
                    width="191"
                    height="190"
                    viewBox="0 0 191 190"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="gradient-svg"
                  >
                    <path
                      className="gradient-path"
                      d="M142.132 121.411C141.989 121.847 139.745 129.672 134.234 137.718C129.463 144.658 124.53 151.655 116.739 151.778C109.078 151.912 106.626 147.206 97.8784 147.206C89.1419 147.206 86.3954 151.655 79.1547 151.912C71.6694 152.219 65.9095 144.331 61.121 137.424C51.3344 123.276 43.7991 97.3314 53.9052 79.9443C58.8776 71.2449 67.815 65.7151 77.5476 65.5641C84.882 65.4254 91.8601 70.5325 96.3148 70.5325C100.891 70.5325 109.333 64.3529 118.238 65.2775C121.967 65.4363 132.397 66.8362 139.116 76.5756C138.588 76.9353 126.637 83.9877 126.77 98.3411C126.95 115.669 141.971 121.352 142.132 121.411ZM112.411 55.9955C116.427 51.0968 119.065 44.3631 118.371 37.6758C112.637 37.9007 105.651 41.4837 101.499 46.3533C97.8281 50.6019 94.5924 57.4405 95.4948 64.0502C101.866 64.4372 108.416 60.7139 112.411 55.9955Z"
                      fill="url(#paint0_linear_3638_52112)" // Initially grey gradient
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3638_52112"
                        x1="77.6556"
                        y1="202.335"
                        x2="154.439"
                        y2="132.464"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#262626" />
                        <stop offset="1" stop-color="#8C8C8C" />
                      </linearGradient>

                      <linearGradient
                        id="paint1_linear_3638_52112"
                        x1="77.6556"
                        y1="202.335"
                        x2="154.439"
                        y2="132.464"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00D6FF" />
                        <stop offset="1" stop-color="#00FF86" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <Custombutton
                    className={"btn-outline w-100"}
                    label={"download now"}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 mb-4">
              <div className="position-relative">
                <div className="download">
                  <h5>ios</h5>

                  <svg
                    width="190"
                    height="190"
                    viewBox="0 0 190 190"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="gradient-svg"
                  >
                    <path
                      className="gradient-path"
                      d="M106.007 56.0156V54.4847L100.429 54.995C98.9079 54.995 97.8937 55.5053 96.8795 56.0156C95.8653 56.5258 95.8653 57.5464 95.8653 58.567C95.8653 59.5875 96.3724 60.0978 96.8795 60.6081C97.8937 61.1184 98.9079 61.6287 99.9221 61.6287C100.936 61.6287 101.443 61.6287 102.458 61.1184C103.472 60.6081 103.979 60.6081 104.486 60.0978C104.993 59.5875 105.5 59.0773 105.5 58.567C106.007 57.5464 106.007 57.0361 106.007 56.0156ZM116.149 48.8716C116.656 47.3407 117.163 46.3202 118.177 45.2996C119.192 44.279 120.206 43.7687 121.22 42.7482C122.741 42.2379 123.755 41.7276 125.277 41.7276C126.798 41.7276 127.812 41.7276 129.333 42.2379C130.348 42.7482 131.362 43.2585 132.376 43.7687C133.39 44.279 133.897 45.2996 134.404 46.3202C134.912 47.3407 135.419 48.3613 135.419 49.3819H131.362C131.362 48.8716 130.855 48.3613 130.855 47.851C130.855 47.3407 130.348 46.8304 129.841 46.3202C129.333 45.8099 128.826 45.8099 128.319 45.2996C127.812 45.2996 126.798 44.7893 126.291 44.7893C125.277 44.7893 124.77 44.7893 123.755 45.2996C123.248 45.8099 122.234 46.3201 121.727 46.8304C121.22 47.3407 120.713 48.3613 120.713 49.3819C120.206 50.4024 120.206 51.423 120.206 52.4436C120.206 53.4641 120.206 54.4847 120.713 55.5053C121.22 56.5258 121.22 57.0361 121.727 58.0567C122.234 58.567 122.741 59.0773 123.755 59.5875C124.263 60.0978 125.277 60.0978 126.291 60.0978C127.812 60.0978 128.826 59.5875 129.841 59.0773C130.855 58.567 131.362 57.5464 131.869 56.0156H135.926C135.926 57.0361 135.419 58.0567 134.912 59.0773C134.404 60.0978 133.897 60.6081 132.883 61.6287C131.869 62.139 130.855 62.6492 129.841 63.1595C128.826 63.6698 127.305 63.6698 126.291 63.6698C124.77 63.6698 123.248 63.1595 122.234 62.6492C120.713 62.139 119.699 61.1184 119.192 60.6081C118.177 59.5875 117.67 58.567 117.163 57.0361C116.656 55.5053 116.656 53.9744 116.656 52.4436C115.135 51.423 115.642 49.8921 116.149 48.8716ZM55.805 42.2379H59.8617V45.8099C60.3688 45.2996 60.3688 44.7893 60.8759 44.279C61.383 43.7687 61.8901 43.2585 62.3972 43.2585C62.9043 42.7482 63.4114 42.7482 64.4256 42.2379C64.9327 42.2379 65.9469 41.7276 66.454 41.7276C67.9752 41.7276 69.4965 42.2379 70.5107 42.7482C71.5249 43.2584 72.5391 44.7893 72.5391 45.8099C73.0462 45.2996 73.0462 44.7893 73.5533 43.7687C74.0604 43.2585 74.5674 42.7482 75.0745 42.2379C75.5816 41.7276 76.0887 41.7276 77.1029 41.2173C77.61 41.2173 78.6242 40.707 79.1313 40.707C80.1455 40.707 81.1597 40.707 82.1738 41.2173C83.188 41.7276 83.6951 42.2379 84.7093 42.7482C85.7235 43.2584 85.7235 44.279 86.2306 45.2996C86.7377 46.3202 86.7377 47.3407 86.7377 48.3613V63.6698H82.6809V50.4024C82.6809 48.8716 82.1738 47.851 81.6667 46.8304C81.1597 45.8099 79.6384 45.8099 78.6242 45.8099C78.1171 45.8099 77.1029 45.8099 76.5958 46.3202C76.0887 46.3202 75.5816 46.8304 75.0745 47.3407C74.5674 47.851 74.5674 48.3613 74.0603 48.8716C74.0603 49.3819 73.5533 49.8921 73.5533 50.9127V64.6904H68.9894V50.4024C68.9894 49.8921 68.9894 49.3819 68.4823 48.8716C68.4823 48.3613 67.9752 47.851 67.4681 47.3407C66.9611 46.8304 66.454 46.8304 65.9469 46.3202C65.4398 46.3202 64.9327 45.8099 64.4256 45.8099C63.9185 45.8099 62.9043 45.8099 62.3972 46.3202C61.8901 46.3202 61.383 46.8304 60.8759 47.3407C60.3688 47.851 60.3688 48.3613 59.8617 48.8716C59.8617 49.3819 59.3547 50.4024 59.3547 50.9127V64.6904H55.2979V42.2379H55.805ZM65.4398 148.887C46.1702 148.887 34 135.11 34 113.678C34 92.2457 46.1702 78.468 65.4398 78.468C84.7093 78.468 96.8795 92.2457 96.8795 113.678C96.8795 135.62 84.7093 148.887 65.4398 148.887ZM101.443 64.6904C100.936 64.6904 99.9221 65.2007 99.415 65.2007C98.4008 65.2007 97.3866 65.2007 96.3725 64.6904C95.3583 64.1801 94.8512 64.1801 93.837 63.1595C93.3299 62.6492 92.8228 62.139 92.3157 61.1184C91.8086 60.0978 91.8086 59.5875 91.8086 58.567C91.8086 56.5258 92.3157 54.995 93.837 53.9744C95.3583 52.9539 97.3866 52.4436 99.9221 51.9333L106.007 51.423V49.8921C106.007 48.3613 105.5 47.851 104.993 46.8304C104.486 45.8099 102.965 45.8099 101.443 45.8099C100.936 45.8099 100.429 45.8099 99.9221 45.8099C99.415 45.8099 98.9079 46.3202 98.4008 46.3202C97.8937 46.8304 97.8937 46.8304 97.3866 47.3407C96.8795 47.851 96.8795 48.3613 96.8795 48.8716H92.8228C92.8228 47.851 93.3299 46.8304 93.3299 46.3202C93.3299 45.8099 94.3441 44.7893 95.3583 44.279C96.3724 43.7687 96.8795 43.2584 97.8937 42.7482C98.9079 42.2379 99.9221 42.2379 101.443 42.2379C102.965 42.2379 103.979 42.2379 104.993 42.7482C106.007 43.2584 107.021 43.7687 108.036 44.279C109.05 44.7893 109.557 45.8099 110.064 46.8304C110.571 47.851 110.571 48.8716 110.571 49.8921V65.2007H106.514V60.6081C106.007 61.1184 106.007 61.6287 105.5 62.139C104.993 62.6492 104.486 63.1595 103.979 63.1595C102.965 64.1801 101.95 64.1801 101.443 64.6904ZM129.333 148.887C114.628 148.887 104.486 141.233 103.979 128.986H113.614C114.121 136.13 121.22 140.723 130.348 140.723C138.968 140.723 145.56 136.13 145.56 130.007C145.56 124.394 141.504 121.332 132.883 118.78L124.263 116.739C111.585 113.678 106.007 108.065 106.007 98.3691C106.007 86.6326 116.149 78.9783 130.348 78.9783C144.546 78.9783 154.181 87.1429 154.688 98.8794H145.053C144.546 91.7354 138.968 87.6532 130.348 87.6532C121.727 87.6532 116.149 92.2457 116.149 98.3691C116.149 103.472 119.699 106.023 128.826 108.575L135.926 110.616C150.124 114.188 155.702 119.801 155.702 129.496C155.195 141.233 145.053 148.887 129.333 148.887ZM65.4398 87.1429C52.2554 87.1429 43.6348 97.3486 43.6348 113.678C43.6348 130.007 51.7483 140.212 65.4398 140.212C78.6242 140.212 87.2448 130.007 87.2448 113.678C87.2448 97.3486 78.6242 87.1429 65.4398 87.1429Z"
                      fill="url(#paint0_linear_3638_52121)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_3638_52121"
                        x1="71.3473"
                        y1="196.625"
                        x2="142.506"
                        y2="107.16"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#262626" />
                        <stop offset="1" stop-color="#8C8C8C" />
                      </linearGradient>
                      <linearGradient
                        id="paint0_hover"
                        x1="71.3473"
                        y1="196.625"
                        x2="142.506"
                        y2="107.16"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#00f" />
                        <stop offset="1" stop-color="#0f0" />
                      </linearGradient>
                    </defs>
                  </svg>

                  <Custombutton
                    className={"btn-outline w-100"}
                    label={"download now"}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <h4 className="text-center mb-5">Other Products</h4>

            <div className="col-lg-6  mb-4">
              <div className="position-relative  h-100">
                <div className="routers  h-100">
                  <div className="row align-items-start align-items-md-center h-100">
                    <div className="col-xxl-6 p-5 p-xxl-5 order-xxl-1 order-2">
                      <h3>Routers</h3>
                      <p>
                        Cosmic runs on a decentralized network of Nodes. Install
                        our PC package to operate a Node and earn passive income
                        through our rewards program.
                      </p>

                      <Link
                        to="/nebula-lite"
                        className="position-relative "
                        style={{ zIndex: "9" }}
                      >
                        <Custombutton
                          label={"learn more"}
                          className={
                            "btn-outline gradient-text gradient-outline px-5 py-3"
                          }
                        />
                      </Link>
                    </div>
                    <div className="col-xxl-6 order-xxl-2 order-1">
                      <div className="d-none d-lg-block">
                        <img
                          className="w-100"
                          src="./assets/images/router-new.png"
                          alt="router-new"
                        />
                      </div>
                      <div className="d-block d-lg-none">
                        <img
                          className="w-100"
                          src="./assets/images/router-new.png"
                          alt="router-new"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6  mb-4">
              <div className="position-relative  h-100">
                <div className="routers  h-100">
                  <div className="row align-items-start align-items-md-center h-100">
                    <div className="col-xxl-6  order-xxl-1 order-2">
                      <div className="d-none d-xxl-block">
                        <img
                          className="w-100 position-relative z-index-1"
                          src="./assets/images/node-new.png"
                          alt="router-new"
                        />
                      </div>
                      <div className="d-block d-xxl-none">
                        <img
                          className="w-100  position-relative "
                          src="./assets/images/node-new.png"
                          alt="router-new"
                        />
                      </div>
                    </div>
                    <div className="col-xxl-6 p-5 p-xxl-5  order-xxl-2 order-2">
                      <h3>Nodes</h3>
                      <p>
                        Cosmic uses a decentralized Node network. Run a Node on
                        your PC and earn passive income through our rewards
                        program.
                      </p>

                      <Link
                        to="/nodes"
                        className="position-relative "
                        style={{ zIndex: "9" }}
                      >
                        <Custombutton
                          label={"learn more"}
                          className={
                            "btn-outline gradient-text gradient-outline px-5 py-3"
                          }
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DVPN;
